'use client';

import { NEXT_ROUTES } from '@bts-web/utils-next-infrastructure';
import { HyperLinkButtonBase } from '../components';
import { isDac8FeatureEnabled } from '../utils/userAccess/checkDac8Enabled';

interface WelcomeContinueButtonProps {
  visual: 'primary' | 'secondary';
  label: string;
}

export const WelcomeContinueButton = ({
  visual,
  label,
}: WelcomeContinueButtonProps) => {
  const destination = isDac8FeatureEnabled()
    ? NEXT_ROUTES.US_PERSON
    : NEXT_ROUTES.TERMS_AND_CONDITIONS;

  return (
    <HyperLinkButtonBase to={destination} visual={visual}>
      {label}
    </HyperLinkButtonBase>
  );
};
